import React from 'react'
import styled, {css} from 'styled-components'
import Container from '../../Layout/Container'
import SVG from 'react-inlinesvg'
import MGSymbol from '../../assets/svg/shape-copy.svg'
import { Link } from 'gatsby'

const StyledFormWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: ${({ noPadding }) => (noPadding ? '0' : '0 24px')};

  ${({ blogListing }) =>
    blogListing &&
    css`
      height: 100%;
      padding: 0;
    `}
`

const StyledFormContainer = styled.div`
  ${({ contactPage }) => (contactPage && 'max-width: 820px;')}
  align-items: center;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 1px 0 rgba(10, 22, 70, 0.1),
    0 0 1px 0 rgba(10, 22, 70, 0.06);
  display: flex;
  flex-direction: column;
  margin-top: -80px;
  padding: 48px 32px;
  width: 100%;

  svg {
    margin-bottom: 14px;
  }

  ${({ theme }) => theme.media.desktop} {
    margin-top: -120px;
    padding: ${({ embedded }) => (embedded ? '48px 20px' : '48px 104px')};
    width: ${({ contactPage }) => (contactPage ? '100%' : '66.666667%')};

    ${({ noShift }) =>
      noShift &&
      css`
        margin-top: 0;
      `}

    ${({ blogListing }) =>
      blogListing &&
      css`
        justify-content: center;
        margin: 0;
        width: 100%;
      `}
  }

  ${({ noShift }) =>
    noShift &&
    css`
      margin-top: 0;
    `}
`

const StyledCopy = styled.p`
  color: #8a94a6;
  font-size: 0.75em;
  line-height: 1.67;
  text-align: center;
  width: 100%;

  ${({ theme }) => theme.media.desktop} {
    width: 80%;
  }

  a {
    color: #4e5d78;
    display: inline-block;
    
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`

const FormSection = ({ 
    blogListing, 
    children, 
    cmsData, 
    contactPage, 
    embedded,
    noPadding,
    noShift, 
  }) => {

  const formType = cmsData.items[1].fields.formType

  return (
    <Container blogListing={blogListing}>
      <StyledFormWrapper blogListing={blogListing} noPadding={noPadding}>
        <StyledFormContainer
          blogListing={blogListing}
          contactPage={contactPage}
          embedded={embedded}
          noShift={noShift}
        >
          <SVG src={MGSymbol} />
          {children}
          {formType === 'blog-subscribe-form' ? (
            <StyledCopy>
              Yes! Send me the Mailgun newsletter. I know that I can unsubscribe at any time and I agree that my data will be treated in accordance with Mailgun's <Link to="/privacy-policy">Privacy Policy</Link>.
            </StyledCopy>
          ) : (
            <StyledCopy>
              By sending this form, I agree that Mailgun may contact me and process my data in accordance with its <Link to="/privacy-policy">Privacy Policy</Link>. 
            </StyledCopy>
          )}
        </StyledFormContainer>
      </StyledFormWrapper>
    </Container>
  )
}

export default FormSection